/* Upstream conversion events. Privacy safe: dispatches a CustomEvent and pushes to
   window.dataLayer when a tag manager is present. Never sends names, emails, phone
   numbers, URLs typed into forms, or any free text. Only event name plus a source,
   step number, or non-sensitive business-type category.

   Manual use:  UpstreamConversion.track('audit_submit', { source: 'audit' })
   Auto wiring:
     click   an element with [data-uw-event] fires that event (source from data-uw-source)
     submit  a <form data-uw-event> fires on submit
     focus   first focus inside [data-uw-start] fires that start event once */
(function () {
  function track(name, detail) {
    if (!name) return;
    detail = detail || {};
    try { document.dispatchEvent(new CustomEvent('uw:' + name, { detail: detail })); } catch (e) {}
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: 'uw_' + name }, detail)); } catch (e) {}
  }
  window.UpstreamConversion = { track: track };

  var started = {};
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-uw-event]') : null;
    if (!el || el.tagName === 'FORM') return;
    track(el.getAttribute('data-uw-event'), { source: el.getAttribute('data-uw-source') || '' });
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target && e.target.closest ? e.target.closest('form[data-uw-event]') : null;
    if (!f) return;
    track(f.getAttribute('data-uw-event'), { source: f.getAttribute('data-uw-source') || '' });
  }, true);
  document.addEventListener('focusin', function (e) {
    var c = e.target && e.target.closest ? e.target.closest('[data-uw-start]') : null;
    if (!c) return;
    var n = c.getAttribute('data-uw-start');
    if (!n || started[n]) return;
    started[n] = 1;
    track(n, { source: c.getAttribute('data-uw-source') || '' });
  }, true);
})();
